import axiosInstance from "./Axios";

export class PostPreferencesApi {
  static savePostPreferences = async (data: any) => {
    try {
      const res = await axiosInstance.post(`post-preferences`, data);
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getPostPreferences = async (post_type: string) => {
    try {
      const res = await axiosInstance.get(`post-preferences`, {
        params: { post_type },
      });
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };
}